<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="userSelectItems"
            v-model="item.users"
            :items="userSelectItems"
            :error-messages="userErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('administration.user.users')"
            item-text="login"
            item-value="@id"
          />
        </v-col>


      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'BadgeForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.userGetSelectItems({'orderCol'  : 'order[login]','order'  : 'asc'});
  },
  data() {
    return {
        name: null,
        users: null,
    };
  },
  computed: {
    isLoading() {
      return (
         this.isLoading_user
       );
    },
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    ...mapFields('user', {
      userSelectItems: 'selectItems',
      isLoading_user : 'isLoading'

    }),
    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    userErrors() {
      const errors = [];

      if (!this.$v.item.users.$dirty) return errors;

      has(this.violations, 'users') && errors.push(this.violations.users);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      userGetSelectItems: 'user/fetchSelectItems'
    }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      userAssembly: {
      },
    }
  }
};
</script>
